import React from 'react';
import ReactDOM from 'react-dom';
import MainRouter from './Router';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <MainRouter />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

